import { DevelopmentManagerPreviewData } from "../../../route/public/development-manager/details/preview/usePreview";
import { PublicDevelopmentManagerDetails } from "../components";
import { DevelopmentManagerDetailsData } from "../models";
import { usePublicDevelopmentManagerDetailsPreviewTemplate } from "./usePublicDevelopmentManagerDetailsPreviewTemplate";

interface PublicDevelopmentManagerDetailsPreviewTemplateProps {
  previewData: DevelopmentManagerPreviewData;
}

export const PublicDevelopmentManagerDetailsPreviewTemplate = ({
  previewData,
}: PublicDevelopmentManagerDetailsPreviewTemplateProps): JSX.Element => {
  const { dataIsLoading, developmentManagerUuid, developmentManagerDetails, developmentManagerSocialMedia } =
    usePublicDevelopmentManagerDetailsPreviewTemplate();

  const developmentManagerDetailsData: DevelopmentManagerDetailsData | undefined =
    developmentManagerDetails && developmentManagerSocialMedia
      ? {
          ...developmentManagerDetails,
          calculatedContactable: false,
          socialMediaData: developmentManagerSocialMedia,
          hero: previewData.hero,
          atAGlance: previewData.atAGlance,
          aboutUs: previewData.aboutUs,
          ourServices: previewData.ourServices,
        }
      : undefined;

  return (
    <div>
      {!dataIsLoading && developmentManagerDetailsData && (
        <PublicDevelopmentManagerDetails
          projectsCoordinates={undefined}
          developmentManagerUuid={developmentManagerUuid}
          isPreview
          developmentManagerDetailsData={developmentManagerDetailsData}
        />
      )}
    </div>
  );
};
